import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Pipe({name: 'keepHtml', pure: false})
export class KeepHtmlPipe implements PipeTransform {
    // https://medium.com/@AAlakkad/angular-2-display-html-without-sanitizing-filtering-17499024b079
    constructor(private sanitizer: DomSanitizer) {
    }

    transform(content) {
        return this.sanitizer.bypassSecurityTrustHtml(content);
    }
}
